export default {
    update: function (el) {
        el.value = el.value.toLowerCase()
    }
}